"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServer = void 0;
const isServer = () => {
    return !(typeof window != "undefined" && window.document);
};
exports.isServer = isServer;
